var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojioneV1FlagForCatalonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "emojione-v1-catalonia-flag-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 26.875C40 30.6719 37.8919 33.75 33.75 33.75H6.25C2.10813 33.75 0 30.6719 0 26.875V13.125C0 9.32812 2.10813 6.25 6.25 6.25H33.75C37.8919 6.25 40 9.32812 40 13.125V26.875Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#emojione-v1-catalonia-flag-clip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#FCDD09"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8,
    width: 40,
    height: 3,
    fill: "#DA121A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 40,
    height: 3,
    fill: "#DA121A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20,
    width: 40,
    height: 3,
    fill: "#DA121A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 40,
    height: 3,
    fill: "#DA121A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojioneV1FlagForCatalonia);
export default __webpack_public_path__ + "static/media/emojione-v1_flag-for-catalonia.bcfd66fdb695dd449ee6be9c6fbf2993.svg";
export { ForwardRef as ReactComponent };